function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState } from 'react';
import { DateRange } from 'common/widgets/date-range-picker/models/date-range';
import { DateRangePresetBarReact } from 'common/widgets/date-range-preset-bar';
import { DisplayContext } from 'common/widgets/date-range-picker/models/types';
import { TrackingUsageContext } from 'common/report/tracking-setup';
import { withStyles } from 'common/util/react';
import { TimeFilter } from 'common/report/dashboards/types';
import { BoardFilter } from 'apps/boards/src/dashboards-app/components/global-filter-bar/types';
import { Segmentation } from 'common/types/reports/query';
import { BreakdownPlaceholder } from 'apps/boards/src/dashboards-app/components/global-filter-bar/breakdown-placeholder';
import { Translatable } from 'common/i18n';
import { FilterItem } from './filter-item';
import { AddButton } from './add-button';
import { FilterPlaceholder } from './filter-placeholder';
import css from './index.module.styl?inline';
import styles from './index.module.styl';
import { BreakdownItem } from './breakdown-item';
const enum ItemType {
  Filter,
  Breakdown,
}
type Props = {
  canClearTime: boolean;
  canUseDataGroups: boolean;
  hideHours?: boolean;
  hideHoursAndOn?: boolean;
  hideAddFilters: boolean;
  hideAddBreakdowns?: boolean;
  maxFilters: number;
  maxHistoryDays: number;
  filters: BoardFilter[];
  addFilterLabel?: Translatable;
  breakdowns: Segmentation[];
  projectHasCohorts: boolean;
  projectId: number;
  projectAsOfDate: string;
  trackName: string;
  workspaceId: number;
  showUpsell: boolean;
  timeFilter: TimeFilter;
  userId: number;
  onChangeTimeFilter: (timeFilter: TimeFilter) => void;
  onChangeFilters: (filters: BoardFilter[]) => void;
  onChangeBreakdowns: (breakdowns: Segmentation[]) => void;
  onClearTimeFilter: () => void;
  onTrack: (ev: CustomEvent) => void;
};
export const GlobalFilterBar = withStyles((props: Props) => {
  var _props$timeFilter;
  const [placeholderType, setPlaceholderType] = useState<ItemType | null>(null);
  const handleDateRangeSelected = (dateRange: DateRange) => {
    const displayText = dateRange.getDisplayText();
    props.onChangeTimeFilter({
      dateRange,
      displayText
    });
  };
  const updateFilter = (index: number, newFilter: Segmentation) => {
    const filters = [...props.filters];
    filters[index] = newFilter;
    props.onChangeFilters(filters);
  };
  const duplicateFilter = (index: number) => {
    const filter = props.filters[index];
    props.onChangeFilters([...props.filters.slice(0, index), _objectSpread({}, filter), ...props.filters.slice(index)]);
  };
  const deleteFilter = (index: number) => {
    const filters = [...props.filters];
    filters.splice(index, 1);
    props.onChangeFilters(filters);
  };
  const updateBreakdown = (index: number, newBreakdown: Segmentation) => {
    const breakdowns = [...props.breakdowns];
    breakdowns[index] = newBreakdown;
    props.onChangeBreakdowns(breakdowns);
  };
  const deleteBreakdown = (index: number) => {
    const breakdowns = [...props.breakdowns];
    breakdowns.splice(index, 1);
    props.onChangeBreakdowns(breakdowns);
  };
  return <div className={styles.container}>
      <DateRangePresetBarReact className={styles.mpDateRangePresetBar} displayContext={DisplayContext.FullLength} dateRange={(_props$timeFilter = props.timeFilter["dateRange"]) !== null && _props$timeFilter !== void 0 ? _props$timeFilter : null} projectAsOfDate={props.projectAsOfDate} maxHistoryDays={props.maxHistoryDays} trackedUseCase={TrackingUsageContext.Report} canClear disableDatePickerMessage='' disableSubDayGranularityMessage='' elref='dateRangePresetBar' onApply={ev => handleDateRangeSelected(ev.detail.dateRange)} onClear={() => props.onClearTimeFilter()} />
      {props.filters.map((filter, index) => <FilterItem key={"filter-".concat(index)} filter={filter} onChange={newFilter => updateFilter(index, newFilter)} onClickDelete={() => deleteFilter(index)} onClickDuplicate={() => duplicateFilter(index)} projectId={props.projectId} workspaceId={props.workspaceId} userId={props.userId} trackName={props.trackName} onTrack={props.onTrack} />)}
      {placeholderType === ItemType.Filter && <FilterPlaceholder onAdd={filter => props.onChangeFilters([...props.filters, filter])} onClose={() => setPlaceholderType(null)} projectId={props.projectId} workspaceId={props.workspaceId} userId={props.userId} trackName={props.trackName} onTrack={props.onTrack} />}
      {props.breakdowns.map((breakdown, index) => <BreakdownItem key={"breakdown-".concat(index)} breakdown={breakdown} onChange={newBreakdown => updateBreakdown(index, newBreakdown)} onClickDelete={() => deleteBreakdown(index)} projectId={props.projectId} workspaceId={props.workspaceId} userId={props.userId} trackName={props.trackName} onTrack={props.onTrack} />)}
      {placeholderType === ItemType.Breakdown && <BreakdownPlaceholder onAdd={breakdown => props.onChangeBreakdowns([...props.breakdowns, breakdown])} onClose={() => setPlaceholderType(null)} projectId={props.projectId} workspaceId={props.workspaceId} userId={props.userId} trackName={props.trackName} onTrack={props.onTrack} />}
      <AddButton onClickAddFilter={() => setPlaceholderType(ItemType.Filter)} onClickAddBreakdown={() => setPlaceholderType(ItemType.Breakdown)} disabled={placeholderType !== null} hideAddBreakdowns={props.hideAddBreakdowns} addFilterLabel={props.addFilterLabel} />
    </div>;
}, css);